export default __webpack_public_path__ + "static/media/odoo_scr_1.05d57d9e.png";